import { Inline, Stack } from 'braid-design-system';
import type { FC } from 'react';

import { TextSkeleton } from 'src/libs/TextSkeleton';

export const VerificationsLoadingState: FC = () => (
  <Stack space="xlarge" data={{ testid: 'verifications-loading' }}>
    <Stack space="small">
      <TextSkeleton borderRadius="full" width="122px" height="medium" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="122px" height="medium" />
      <TextSkeleton borderRadius="full" width="106px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="106px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="175px" height="medium" />
      <TextSkeleton borderRadius="full" width="294px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="270px" height="medium" />
      <TextSkeleton borderRadius="full" width="294px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="192px" height="medium" />
      <TextSkeleton borderRadius="full" width="427px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>

    <Stack space="small">
      <TextSkeleton borderRadius="full" width="427px" height="small" />
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
      <Inline
        collapseBelow="tablet"
        space={{ mobile: 'small', tablet: 'xxlarge' }}
      >
        <TextSkeleton borderRadius="full" width="106px" height="small" />
        <TextSkeleton borderRadius="full" width="106px" height="small" />
      </Inline>
    </Stack>
  </Stack>
);
